module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.scrollList.length > 0) ? _c('div', {
    staticClass: "scroll-list"
  }, [_c('ul', _vm._l((_vm.scrollList), function(item, index) {
    return _c('li', [(item.type == 'H4') ? _c('p', {
      staticClass: "main-link",
      attrs: {
        "id": item.title
      },
      on: {
        "click": function($event) {
          return _vm.scrollTo(item, $event)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (item.type == 'H5') ? _c('p', {
      staticClass: "sub-link",
      attrs: {
        "id": item.title
      },
      on: {
        "click": function($event) {
          return _vm.scrollTo(item, $event)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()])
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42c34184!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/ScrollNav.vue
// module id = 712
// module chunks = 4